import { useEffect, useState } from 'preact/hooks';
import { KEY_ACTIONS, actionLabel, keyChord, resetKeyBindings, setKeyBinding, subscribeKeyBindings } from '@/keybindings';

export function KeybindsTab() {
  const [, changed] = useState(0);
  const [recording, setRecording] = useState<string | null>(null);
  const [hint, setHint] = useState('');
  useEffect(() => subscribeKeyBindings(() => changed(n => n + 1)), []);
  return <div class='flex flex-col gap-2 p-2' data-keybind-settings>
    <p class='text-xs opacity-70'>Select a control, then press a key. Shift combinations are supported. Touch controls work independently.</p>
    <button type='button' class='btn btn-sm' onClick={() => {resetKeyBindings();setRecording(null);}}>Restore defaults</button>
    {hint && <p role='status' class='text-xs text-warning'>{hint}</p>}
    {KEY_ACTIONS.map(a => <div class='flex items-center justify-between gap-2' key={a.id}>
      <label class='text-xs' for={`bind-${a.id}`}>{a.label}</label>
      <input id={`bind-${a.id}`} data-keybind-capture data-keybind-action={a.id} readOnly
        inputMode='none' class='input input-sm w-36 cursor-pointer text-center' aria-label={`${a.label} key`}
        value={recording === a.id ? 'Press a key…' : actionLabel(a.id)}
        onFocus={() => {setRecording(a.id);setHint('');}} onBlur={() => setRecording(null)}
        onKeyDown={e => {
          e.preventDefault(); e.stopPropagation(); if(e.repeat) return;
          if(e.code === 'Escape') {e.currentTarget.blur();return;}
          if(e.code === 'Backspace' || e.code === 'Delete') setKeyBinding(a.id, null);
          else if (e.ctrlKey && !e.code.startsWith('Control') || e.metaKey || e.altKey || e.code === 'Enter' || (e.code.startsWith('Shift') && a.id !== 'pk')) {
            setHint('Choose a key without Ctrl, Alt or Command. Escape cancels.');return;
          } else setKeyBinding(a.id, keyChord(e));
          e.currentTarget.blur();
        }} />
    </div>)}
    <p class='text-xs opacity-70'>Reassigning a key removes its previous action. Delete clears a control. Chat uses Enter; Escape cancels walking. Ctrl+P opens commands; Ctrl+mouse wheel zooms.</p>
  </div>;
}
